import React from 'react';
import { useDeepEqualMemo } from './hooks/useDeepEqualMemo';

export interface DamzContextProps {
  GlobalComponent?: React.ComponentType<any>;
  DrawerComponent?: React.ComponentType<any>;
  PageComponent?: React.ComponentType<any>;
  isStandalonePage?: boolean;
}

export const DamzContext = React.createContext<DamzContextProps>({});
DamzContext.displayName = 'DamzContext';

export const DamzContextProvider: React.FC<{
  context: DamzContextProps;
  children: React.ReactNode;
}> = props => {
  const ctx = useDeepEqualMemo(props.context);
  return (
    <DamzContext.Provider value={ctx}>{props.children}</DamzContext.Provider>
  );
};
DamzContextProvider.displayName = 'DamzContextProvider';
